import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionBoqVersionsService } from '../services/constructionBoqVersions.service';
import type { ConstructionBoqVersion } from '../types/construction-boq.types';
import { toast } from 'sonner';

export function useBoqVersions(boqId: string) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['construction-boqs', 'versions', boqId],
    queryFn: () => ConstructionBoqVersionsService.getBoqVersions(boqId),
    enabled: !!boqId,
  });

  const createMutation = useMutation({
    mutationFn: (data: Partial<ConstructionBoqVersion>) => 
      ConstructionBoqVersionsService.createBoqVersion({ ...data, boq_id: boqId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-boqs', 'versions', boqId] });
      toast.success('Khởi tạo phiên bản mới thành công');
    },
    onError: (error: any) => {
      toast.error('Lỗi khi tạo phiên bản: ' + error.message);
    }
  });

  return {
    versions: query.data || [],
    isLoading: query.isLoading,
    error: query.error,
    createVersion: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
  };
}
